import ServerSettings from "../../../gd/settings/server-settings/server-settings"

const fieldsConfig = {
    'expanded': {
        type            : 'value',
        defaultValue    : {}
    },
}

const debug = false
// const debug = "UserSettingsViewsGoals"

export default class UserSettingsViewsGoals extends ServerSettings {

    public expanded: any

    constructor(config: any) {

        super(config, fieldsConfig)

        this.expanded = this.initValue('expanded')
    }

    toJson() {
        const result = {}

        this.valueToJson(result, 'expanded')

        debug && console.log(debug, 'toJson', result, this)

        return result
    }
}
